import '@stitch-fix/kufak-fe-infra/src/babel/core-js';
import 'intersection-observer'; // polyfill for react-intersection-observer

import ReactComponentsRails from '@stitch-fix/fe-infra-webpack-rails/react';
import { setAppElement } from '@stitch-fix/mode-react';
import '@stitch-fix/client-analytics-reporter/setup/index';
import { init as initPerformanceAnalytics } from '@stitch-fix/client-analytics-reporter';
import ProductDetailsPageWrapper from '../src/components/ProductDetailsPageWrapper';
import ShoppingBag from '../src/components/ShoppingBag';
import MobileSizeGuidePage from '../src/components/SizeGuide/MobileSizeGuidePage';
import OutfitSandbox from '../src/components/OutfitSandbox/OutfitSandbox';
import '../styles/application.scss';
import wrapRootComponents from '../src/components/shared/wrapRootComponents';
import setupMocks from '../shared/setupMocks';

document.addEventListener('DOMContentLoaded', () => {
  // Accessibility setting for modal, see:
  // https://github.com/stitchfix/mode-react/blob/dec3a638dddebada7c346f21247066b5250b4215/src/Modal/Modal.tsx#L51-L63
  setAppElement('#a11y-root');
});

initPerformanceAnalytics({
  appId: window.gon.dd_rum_app_id,
  appName: window.gon.appName,
  clientToken: window.gon.dd_rum_client_token,
  env: window.gon.env,
  version: window.gon.release_sha,
  sampleRate: 100,
});

setupMocks().then(() => {
  ReactComponentsRails.setup(
    wrapRootComponents({
      ProductDetailsPageWrapper: {
        Component: ProductDetailsPageWrapper,
        getV2ScreenViewData: ({ selectedSkuId }) => ({
          name: 'pdp',
          schema: 'sku_screen_view',
          sku_id: selectedSkuId || '',
        }),
      },
      ShoppingBag: {
        Component: ShoppingBag,
        getV2ScreenViewData: () => ({
          name: 'shopping_bag',
          schema: 'screen_view',
        }),
      },
      MobileSizeGuidePage: {
        Component: MobileSizeGuidePage,
        getV2ScreenViewData: () => ({
          name: 'freestyle',
          schema: 'screen_view',
        }),
      },
      OutfitSandbox: {
        Component: OutfitSandbox,
        getV2ScreenViewData: () => ({
          name: 'outfit_sandbox',
          schema: 'screen_view',
        }),
      },
    }),
  );
});
